import { AnalyticsStore, ExperimentStore, PageStore, SerializedData, Store } from 'bernie-core';
import { Context } from 'bernie-context';
import { Logger, NOOP_LOGGER } from 'bernie-logger';

interface VacEvent {
  type: string;
}

export class VirtualAgentControlStore extends Store {
  public readonly VAC_WIDGET_OPENED_EVENT: string = 'VAC_WidgetOpened';
  public readonly VAC_WIDGET_OPENED_RFRR_ID: string = 'VA.FAB.Open';
  public readonly VAC_WIDGET_OPENED_DESCRIPTION: string = 'VAC Opened';

  public readonly VAC_WIDGET_CLOSED_EVENT: string = 'VAC_WidgetClosed';
  public readonly VAC_WIDGET_CLOSED_RFRR_ID: string = 'VA.FAB.Closed';
  public readonly VAC_WIDGET_CLOSED_DESCRIPTION: string = 'VAC Closed';

  /* tslint:disable:unnecessary-constructor */
  constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
  }

  public hydrate(): void {
    // Since I'm not hydrating anything server side, I don't need this
  }

  public shouldInjectChatbot(context: Context, page: PageStore, experiment: ExperimentStore) {
    /* Logging here avoids making any calls to BFF when the experiment isn't bucketed.
     * If the experiment is bucketed, we include the Chatbot's JavaScript inline and *then*
     * call the backend to fetch an auth token. The alternative is calling the backend every
     * page load to fetch the JavaScript URL if bucketed, or no JavaScript URL if unbucketed.
     * Since the JavaScript URLs are stored in configs in shopping-pwa, we can skip the backend
     * and simply not call it if unbucketed. Also the experiments are OR'ed, and there is no way
     * to OR experiments with AbacusExperiment */
    if (this.getUsVariant(experiment) > 0) {
      experiment.logExperiment(context, page, {
        name: 'Lshop_Vac_Chatbot',
        bucket: 1,
        logOnServer: false,
      });

      return true;
    } else if (this.getUkVariant(experiment) > 0) {
      experiment.logExperiment(context, page, {
        name: 'Lshop_Vac_Chatbot_UK',
        bucket: 1,
        logOnServer: false,
      });

      return true;
    } else if (this.getCometVariant(experiment) > 0) {
      experiment.logExperiment(context, page, {
        name: 'Lshop_Vac_Chatbot_COMET',
        bucket: 1,
        logOnServer: false,
      });

      return true;
    }

    return false;
  }

  public getUsVariant(experiment) {
    return experiment.exposures && experiment.exposures.Lshop_Vac_Chatbot && experiment.exposures.Lshop_Vac_Chatbot.bucket;
  }

  public getUkVariant(experiment) {
    return experiment.exposures && experiment.exposures.Lshop_Vac_Chatbot_UK && experiment.exposures.Lshop_Vac_Chatbot_UK.bucket;
  }

  public getCometVariant(experiment) {
    return experiment.exposures && experiment.exposures.Lshop_Vac_Chatbot_COMET && experiment.exposures.Lshop_Vac_Chatbot_COMET.bucket;
  }

  public eventHandler(analyticsStore: AnalyticsStore, event: VacEvent) {
    switch (event.type) {
      case this.VAC_WIDGET_OPENED_EVENT:
        analyticsStore.trackEvent(this.VAC_WIDGET_OPENED_RFRR_ID, this.VAC_WIDGET_OPENED_DESCRIPTION, null);
        break;
      case this.VAC_WIDGET_CLOSED_EVENT:
        analyticsStore.trackEvent(this.VAC_WIDGET_CLOSED_RFRR_ID, this.VAC_WIDGET_CLOSED_DESCRIPTION, null);
        break;
      default:
        break;
    }
  }
}
